import Annoncement from './Annoncement';

export default Annoncement;
